import React from 'react';
import { LightbulbIcon, CheckCircleIcon } from 'lucide-react';
export const Solution = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-344">
      <div className="bg-blue-50 p-5 rounded-lg mb-8 border-l-4 border-blue-500" data-id="element-345">
        <h2 className="text-xl font-bold text-blue-800 flex items-center mb-4" data-id="element-346">
          <LightbulbIcon className="w-6 h-6 mr-2 text-blue-600" data-id="element-347" />
          De wetenschapper die zijn eigen werk afkeurde
        </h2>
        <p className="mb-4 leading-relaxed" data-id="element-348">
          David L. Mech is geen onbekende naam in de dierenwereld. Als
          wereldberoemd bioloog vormde zijn werk naar wolven uit de jaren '70 de
          basis waarop miljoenen hondeneigenaren met hun hond om gaan.
        </p>
        <p className="mb-4 leading-relaxed" data-id="element-349">
          Maar in 1999 deed Mech een ontdekking die alles veranderde. En
          sindsdien probeert hij wanhopig zijn eigen theorie te corrigeren.
        </p>
        <p className="text-lg font-semibold text-blue-800 mb-4" data-id="element-350">
          "Het probleem is dat mijn oorspronkelijke onderzoek werd uitgevoerd op
          wolven in gevangenschap," legt Mech uit in latere interviews. Het is
          daarom niet te vergelijken met hoe honden zich in een huishouden
          gedragen.
        </p>
      </div>
      <div className="w-full mb-6" data-id="element-351">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7ybqiWhtxfB1fDCg5RxnBJ/Scherm%C2%ADafbeelding_2025-09-01_om_23.36.13.png" alt="Hond die zich onderwerpt aan dominantie training in woonkamer" className="w-full h-auto rounded-lg shadow-md" data-id="element-352" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-353">
          "Dominantie training is gebaseerd op verouderde wetenschap die de
          onderzoeker zelf heeft afgekeurd"
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-354">
        Waarom niemand je dit vertelt - De cover-up
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-355">
        Toen hij later wilde wolvenroedels in hun natuurlijke habitat
        bestudeerde, zag hij iets compleet anders. Geen agressieve alfa's die
        constant moesten vechten. Gewoon families, ouderparen met hun jongen die
        samenwerkten.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-356">
        Nog belangrijker: ondanks dat wolven en honden verwant zijn, gedragen ze
        zich ook sociaal anders in groepen. Honden hebben een veel flexibelere
        sociale structuur.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-357">
        "Het is een verouderd, achterhaald concept dat we 25 jaar geleden al
        hebben gecorrigeerd. Maar het concept blijft hangen, vooral in de
        hondentraining, en is moeilijk uit te roeien."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-358">
        Maar deze toepassing is fout volgens Mech. "Het gebruik van
        'dominantietheorie' in hondentraining leidt tot aversieve methoden en
        een onjuist begrip van de hond-mens relatie. Een hond die op de bank
        springt, probeert niet de 'alfa' te zijn; Je hond is niet je rivaal die
        je moet 'domineren'"
      </p>
      <p className="mb-6 leading-relaxed font-semibold" data-id="element-359">
        De vraag is: als de grondlegger van de dominantie theorie deze al 25
        jaar probeert af te keuren, waarom weten baasjes dit dan nog niet?
      </p>
      <ul className="mb-6 space-y-3" data-id="element-360">
        <li className="flex items-start" data-id="element-361">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-362" />
          <span data-id="element-363">
            <strong data-id="element-364">Het lijkt soms te werken.</strong> Sommige honden laten zich
            wel africhten met dominantie, dat is het verwarrende voor veel
            baasjes. Dit geeft het gevoel dat de methode effectief zou zijn.
          </span>
        </li>
        <li className="flex items-start" data-id="element-365">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-366" />
          <span data-id="element-367">
            <strong data-id="element-368">Gemakkelijke marketing.</strong> Een afgerichte hond die
            exact doet wat je zegt ziet er stoer en krachtig uit.
          </span>
        </li>
        <li className="flex items-start" data-id="element-369">
          <CheckCircleIcon className="w-5 h-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-370" />
          <span data-id="element-371">
            <strong data-id="element-372">De trainings-industrie heeft er belang bij.</strong>{' '}
            Miljarden worden verdiend met dominantie-training.
          </span>
        </li>
      </ul>
      <p className="mb-6 leading-relaxed" data-id="element-373">
        Leren samenwerken en soms naar de behoeftes van je hond luisteren in
        plaats van andersom klinkt minder stoer, maar is wat moderne wetenschap
        aantoont als effectiever.
      </p>
    </section>;
};